import { render, staticRenderFns } from "./ButtonOutline.vue?vue&type=template&id=6b423539&scoped=true"
import script from "./ButtonOutline.vue?vue&type=script&lang=js"
export * from "./ButtonOutline.vue?vue&type=script&lang=js"
import style0 from "./ButtonOutline.vue?vue&type=style&index=0&id=6b423539&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b423539",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b423539')) {
      api.createRecord('6b423539', component.options)
    } else {
      api.reload('6b423539', component.options)
    }
    module.hot.accept("./ButtonOutline.vue?vue&type=template&id=6b423539&scoped=true", function () {
      api.rerender('6b423539', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/atoms/ButtonOutline.vue"
export default component.exports